import { render, staticRenderFns } from "./Socials.vue?vue&type=template&id=9ceaf23a&scoped=true&"
import script from "./Socials.vue?vue&type=script&lang=ts&"
export * from "./Socials.vue?vue&type=script&lang=ts&"
import style0 from "./Socials.vue?vue&type=style&index=0&id=9ceaf23a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ceaf23a",
  null
  
)

export default component.exports